<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="700px"
        transition="slide-y-transition"
        eager
        :persistent="actionLoading"
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 v-if="productPropertyValue" class="text-subtitle-1">
                    <template v-if="!isNewProductionProductPropertyValue">
                        Edycja definicji
                    </template>
                    <template v-else>
                        Nowa definicja
                    </template>
                    - <strong>{{ productPropertyValue.productProperty.name }}: {{ productPropertyValue.name }}</strong>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-autocomplete
                            v-model="productProductionPropertyValue.productProductionPropertyId"
                            :items="availableProductProductionProperties"
                            label="Cecha produkcyjna"
                            item-value="id"
                            item-text="verboseName"
                            dense
                            outlined
                            :error-messages="productProductionPropertyIdErrors"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                            v-model="productProductionPropertyValue.productProductionPropertyValue"
                            label="Wartość"
                            dense
                            outlined
                            :error-messages="productProductionPropertyValueErrors"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveProductionProductPropertyValue"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ProductionProductPropertyValueDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        productionProductPropertyValueData: {
            type: Object,
            default: () => {}
        },
        availableProductProductionPropertiesData: {
            type: Array,
            default: () => []
        },
        productPropertyValue: {
            type: Object,
            default: () => {}
        },
        actionLoading: {
            type: Boolean
        }
    },
    data() {
        return {
            productProductionPropertyValue: {
                productProductionPropertyId: null,
                productPropertyValueJoinId: null,
                productProductionPropertyValue: null
            },
            availableProductProductionProperties: []
        }
    },
    computed: {
        isNewProductionProductPropertyValue() {
            return isEmpty(this.productionProductPropertyValueData)
        },
        // Walidacje
        productProductionPropertyIdErrors() {
            const errors = []

            if (!this.$v.productProductionPropertyValue.productProductionPropertyId.$dirty) return errors
            !this.$v.productProductionPropertyValue.productProductionPropertyId.required && errors.push('Proszę wybrać cechę produkcyjną.')

            return errors
        },
        productProductionPropertyValueErrors() {
            const errors = []

            if (!this.$v.productProductionPropertyValue.productProductionPropertyValue.$dirty) return errors
            !this.$v.productProductionPropertyValue.productProductionPropertyValue.required && errors.push('Proszę podać wartość.')

            return errors
        },
    },
    validations() {
        const rules = {
            productProductionPropertyValue: {
                productProductionPropertyId: {
                    required
                },
                productProductionPropertyValue: {
                    required
                }
            }
        }

        return rules
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.availableProductProductionProperties = JSON.parse(JSON.stringify(this.availableProductProductionPropertiesData))

                if (!this.isNewProductionProductPropertyValue) {
                    this.productProductionPropertyValue = JSON.parse(JSON.stringify(this.productionProductPropertyValueData))
                    this.productProductionPropertyValue.productProductionPropertyId = this.productionProductPropertyValueData.productProductionProperty.id

                    if (!this.availableProductProductionProperties.some(property => {
                        return property.id === this.productProductionPropertyValue.productProductionPropertyId
                    })) {
                        this.availableProductProductionProperties.push(this.productProductionPropertyValue.productProductionProperty)
                    }
                } else {
                    this.productProductionPropertyValue.productPropertyValueJoinId = this.productPropertyValue.productPropertyValueJoinId
                }
            } else {
                setTimeout(() => {
                    this.productProductionPropertyValue = {
                        productPropertyValueJoinId: null,
                        productProductionProperty: {
                            id: null
                        },
                        productProductionPropertyValue: null
                    }
                    this.availableProductProductionProperties = []
                    this.$v.$reset()
                }, 500)
            }
        }
    },
    methods: {
        saveProductionProductPropertyValue() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.$emit('on-save', this.productProductionPropertyValue, this.isNewProductionProductPropertyValue)
        },
        onClose() {
            if (!this.actionLoading) {
                this.$emit('on-close')
            }
        }
    }
}
</script>